import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateOrganizationType = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, subdomain }) => {
            return client.put(
                replaceParameters(ORGANIZATION.UPDATE_TYPE_ORGANIZATION.url, { uuid }),
                { subdomain }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateOrganizationType;